import { Box, IconButton, Typography, useTheme } from '@mui/material'
import { lighten } from '@mui/system/colorManipulator'

import { concatToSXProp } from 'utils/style'

import RecordingIcon from '../icons/RecordingIcon'
import StopIcon from '../icons/StopIcon'
import { AudioRecord as AudioRecordProps } from '../interface'
import audioRecordStyles from '../styles'
import { formattingTime } from '../utils'

type RecordingBoxProps = Pick<AudioRecordProps, 'recordingText'> & {
  duration: number
  stopRecording: () => void
}

export default function RecordingBox({
  recordingText,
  duration,
  stopRecording,
}: RecordingBoxProps): JSX.Element {
  const { audioWrap, iconBox, innerText, recordTime, flexBox, recordText } = audioRecordStyles

  const theme = useTheme()
  const primaryColor = theme.palette.primary.main

  return (
    <Box
      sx={concatToSXProp(audioWrap, {
        ...flexBox,
        borderColor: lighten(theme.palette.primary.main, 0.75),
      })}
    >
      <Box sx={iconBox}>
        <RecordingIcon color={primaryColor} />
      </Box>
      <Typography sx={concatToSXProp(innerText, recordText)}>{recordingText}</Typography>
      <Typography sx={recordTime}>{formattingTime(duration)}</Typography>
      <IconButton onClick={stopRecording} sx={iconBox}>
        <StopIcon color={primaryColor} />
      </IconButton>
    </Box>
  )
}
